import { CircularProgress } from '@mui/material'
import React from 'react'

const Loader = ({className}) => {
  return (
    <div className={`d-flex justify-content-center ${className}`}><CircularProgress color="primary" /></div>
  )
}

export default Loader